import * as wallet from './wallet';

const exportedObject = {
    api: {
        wallet,
    },
};

export default exportedObject;
